import apiActions from '../actions/ApiActions';

function setUserResponseQueue(state, action) {
    const newData = {
        userResponseQueue: action.queue.slice(0),
    };
    return Object.assign({}, state, newData);
}

function setUserResponseQueueAndPendingRequest(state, action) {
    const pendingResponses = state.pendingResponses.slice(0);
    pendingResponses.push(action.requestId);
    const newData = {
        userResponseQueue: action.queue.slice(0),
        pendingResponses,
    };
    return Object.assign({}, state, newData);
}

function setUserResponseQueueStatus(state, action) {
    const newData = {
        userResponseQueueStatus: {
            lastResult: action.lastResult,
            lastDateTime: action.lastDateTime,
        },
    };
    return Object.assign({}, state, newData);
}

const defaultState = {
    isOnline: !window.offlineMode,
    isServerOK: true,
    userResponseQueue: [],
    pendingResponses: [],
    userResponseQueueStatus: {
        lastResult: undefined,
        lastDateTime: undefined,
    },
    isPreloading: false,
};

function removePendingResponse(state, requestId) {
    const pendingResponses = state.pendingResponses.filter((item) => { return item !== requestId; });
    return Object.assign({}, state, { pendingResponses });
}

export default function (state = defaultState, action) {
    switch (action.type) {
    case apiActions.types.API_SET_IS_ONLINE:
        return Object.assign({}, state, { isOnline: action.isOnline });

    case apiActions.types.API_SET_IS_SERVER_OK:
        return Object.assign({}, state, { isServerOK: action.isServerOK });

    case apiActions.types.API_SET_CONNECTION_STATUS:
        return Object.assign({}, state, { connectionStatus: action.status });

    case apiActions.types.API_SET_PRELOADING_STATUS:
        return Object.assign({}, state, { isPreloading: action.isPreloading });

    case apiActions.types.API_SET_USER_RESPONSE_QUEUE_AND_PENDING_REQUEST:
        return setUserResponseQueueAndPendingRequest(state, action);

    case apiActions.types.API_SET_USER_RESPONSE_QUEUE:
        return setUserResponseQueue(state, action);

    case apiActions.types.API_SET_USER_RESPONSE_QUEUE_STATUS:
        return setUserResponseQueueStatus(state, action);

    case apiActions.types.API_REMOVE_PENDING_RESPONSE_REQUEST:
        return removePendingResponse(state, action.requestId);

    default:
        return state;
    }
}
